/* Progressive enhancement: filters remain usable without JavaScript. */
(() => {
  function initialize(root = document) {
    root.querySelectorAll('.at-dachshund-catalog').forEach(catalog => {
      const button = catalog.querySelector('.at-dachshund-filter-toggle');
      const form = catalog.querySelector('#AtCarrierFilters');
      if (!button || !form || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const media = matchMedia('(max-width: 1024px)');
      const active = !!form.querySelector('input:checked, input[type="number"][value]');
      let expanded = active;
      function update() {
        button.hidden = !media.matches;
        form.hidden = media.matches && !expanded;
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('span').textContent = expanded ? '−' : '+';
      }
      button.addEventListener('click', () => { expanded = !expanded; update(); });
      media.addEventListener('change', update);
      update();
    });
  }
  initialize();
  if (!window.atoupetDachshundEditorBound) {
    window.atoupetDachshundEditorBound = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
